/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Testimonials_Subtitle_BoldInputs */

const en_testimonials_subtitle_bold = /** @type {(inputs: Testimonials_Subtitle_BoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`and they love it.`)
};

const es_testimonials_subtitle_bold = /** @type {(inputs: Testimonials_Subtitle_BoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`y les encanta.`)
};

/**
* | output |
* | --- |
* | "and they love it." |
*
* @param {Testimonials_Subtitle_BoldInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const testimonials_subtitle_bold = /** @type {((inputs?: Testimonials_Subtitle_BoldInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Testimonials_Subtitle_BoldInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_testimonials_subtitle_bold(inputs)
	return en_testimonials_subtitle_bold(inputs)
});